
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/become-a-creator",
      function () {
        return require("private-next-pages/help/become-a-creator.tsx");
      }
    ]);
  